import { CommonModule } from '@angular/common';
import { Component, inject, output, signal, input } from '@angular/core';
import { MessageService, SimulationService } from '@services';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'bo-control-panel',
  templateUrl: './control-panel.component.html',
  standalone: true,
  imports: [AngularSvgIconModule, CommonModule],
})
export class ControlPanelComponent {
  isScreenshot = input<boolean>();
  takeScreenshot = output<void>();
  expandMessages = output<boolean>();

  protected messageService = inject(MessageService);
  protected simulationService = inject(SimulationService);

  messageHistory = this.messageService.messages;
  addedMessageToHistory = this.messageService.addedMessageToHistory;

  messagesExpanded = signal(false);

  recordingTime = this.simulationService.recordingTimeString;
}
